var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgChairOffice(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "21px",
    height: "23px",
    viewBox: "0 0 21 23",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "chair-office") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Carpool-Web",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Event-admin/carpool/book-a-ride",
    transform: "translate(-498.000000, -405.000000)",
    fill: "#6173FE",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-22",
    transform: "translate(464.000000, 110.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-12",
    transform: "translate(24.000000, 284.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-10",
    transform: "translate(0.000000, 2.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "chair-office",
    transform: "translate(10.000000, 9.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M3.20000001,16 L3.20000001,12.8 C3.20000001,11.9165 2.4835,11.2 1.6,11.2 C0.716500001,11.2 0,11.9165 0,12.8 L0,16 C0,16.8835 0.716500001,17.6 1.6,17.6 C2.4835,17.6 3.20000001,16.8835 3.20000001,16 Z M18.8,11.2 C17.9165,11.2 17.2,11.9165 17.2,12.8 L17.2,16 C17.2,16.8835 17.9165,17.6 18.8,17.6 C19.6835,17.6 20.4,16.8835 20.4,16 L20.4,12.8 C20.4,11.9165 19.6835,11.2 18.8,11.2 Z M13.4,1.6 C13.4,0.716500001 12.6835,-2.85737799e-14 11.8,-2.85196812e-14 L8.60000002,-2.83237377e-14 C7.71650002,-2.82696389e-14 7,0.716500001 7,1.6 C7,2.4835 7.71650002,3.20000001 8.60000002,3.20000001 L11.8,3.20000001 C12.6835,3.20000001 13.4,2.4835 13.4,1.6 Z M16.6,8.00000001 C16.6,6.23250001 15.1675,4.80000001 13.4,4.80000001 L7.00000001,4.80000001 C5.23250001,4.80000001 3.80000001,6.23250001 3.80000001,8.00000001 L3.80000001,17.6 L16.6,17.6 L16.6,8.00000001 Z M17.4863593,19.9116667 C17.3048977,19.367159 16.7953105,18.9999058 16.2213637,19 L3.77890769,19 C3.20515971,19 2.69557818,19.3670834 2.51391216,19.9116667 L2.06933039,21.245 C1.78183141,22.1083334 2.42432914,23 3.33474259,23 L8.66680709,23 L11.3334643,23 L16.6655288,23 C17.5755256,23 18.21844,22.1083334 17.9305244,21.245 L17.4863593,19.9116667 Z",
    id: "Shape"
  })))))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgChairOffice);
export default __webpack_public_path__ + "static/media/chair-office.d65b49c5.svg";
export { ForwardRef as ReactComponent };